import React from 'react';

import { performanceDirections } from './performanceStatsUtils';
import { capitalize } from '../../../../utils/formatting';

// The cards render on other players' profiles too, where the second person would
// be addressing the wrong person.
const OWN_PROFILE_POSSESSIVE = 'your';
const OTHER_PROFILE_POSSESSIVE = 'their';

export const profilePossessive = (isOwnProfile) => {
    return isOwnProfile ? OWN_PROFILE_POSSESSIVE : OTHER_PROFILE_POSSESSIVE;
};

const insightLabel = (insight) => {
    return insight.direction === performanceDirections.AT
        ? 'at'
        : `${insight.percentLabel}% ${insight.direction}`;
};

// `classes` is the caller's own CSS module: the Stats tab and the Overview teaser
// style the same banner differently, so the markup is shared but the styles are not.
export const insightBannerClass = (direction, classes) => {
    if (direction === performanceDirections.ABOVE) { return classes.insightBannerAbove; }
    if (direction === performanceDirections.BELOW) { return classes.insightBannerBelow; }
    return classes.insightBannerAt;
};

export const insightBannerText = (insight, classes, dataTestId, isOwnProfile = true) => {
    const possessive = profilePossessive(isOwnProfile);
    return (
        <React.Fragment>
            Played <span className={classes.insightBannerEmphasis} data-testid={dataTestId && `${dataTestId}.emphasis`}>{insightLabel(insight)}</span> {possessive} UTR.
        </React.Fragment>
    );
};

export const impactSentence = (impactWeight, dataTestId, isOwnProfile = true) => {
    const possessive = profilePossessive(isOwnProfile);
    return (
        <React.Fragment>
            Result had <strong data-testid={dataTestId && `${dataTestId}.value`}>{capitalize(impactWeight)}</strong> impact on {possessive} UTR.
        </React.Fragment>
    );
};
